/**
 * Maps route pathname to language config key.
 * Add new languages here - no new folders needed.
 */
export const ROUTE_TO_LANG = {
  '/learner/english-language-learning': 'en',
  '/learner/japanese-language-learning': 'ja',
  '/learner/language-learning': 'de',
};

export const LANGUAGE_CONFIG = {
  en: {
    langCode: 'en',
    fromPage: '/learner/english-language-learning',
    flagSrc: '/Flag/En.svg',
    flagAlt: 'English',
    title: 'English Language Learning',
  },
  ja: {
    langCode: 'ja',
    fromPage: '/learner/japanese-language-learning',
    flagSrc: '/Flag/Ja.png',
    flagAlt: 'Japanese',
    title: 'Japanese Language Learning',
  },
  de: {
    langCode: 'de',
    fromPage: '/learner/language-learning',
    flagSrc: '/Flag/De.png',
    flagAlt: 'German',
    title: 'German Language Learning',
  },
};
